import { render, staticRenderFns } from "./v-qrcode.vue?vue&type=template&id=76c7c52a&"
import script from "./v-qrcode.vue?vue&type=script&lang=js&"
export * from "./v-qrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports